document.addEventListener('DOMContentLoaded', function () {
  const listingTwo = document.querySelector('.blogListPostsTwo');

  if (listingTwo) {
    const btn = document.getElementById('loadmore-btn');
    let currentPage = 1;
    let activeFilters = {};

    // ---------------------------------------------------------------
    // Unified click handler — covers dropdowns AND legacy button filters
    // ---------------------------------------------------------------
    listingTwo.addEventListener('click', function (e) {
      // 1. Dropdown toggle open/close
      const toggleBtn = e.target.closest('.blogFilters__dropdown-toggle');
      if (toggleBtn) {
        e.preventDefault();
        const dropdown = toggleBtn.closest('.blogFilters__dropdown');
        const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';

        // Close all other open dropdowns first
        listingTwo.querySelectorAll('.blogFilters__dropdown--open').forEach(function (d) {
          if (d !== dropdown) {
            d.classList.remove('blogFilters__dropdown--open');
            d.querySelector('.blogFilters__dropdown-toggle').setAttribute('aria-expanded', 'false');
          }
        });

        toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        dropdown.classList.toggle('blogFilters__dropdown--open', !isOpen);
        return;
      }

      // 2. Dropdown item selected
      if (e.target.classList.contains('blogFilters__dropdown-link')) {
        e.preventDefault();
        const link = e.target;
        const taxonomy = link.dataset.taxonomy;
        const filterVal = link.dataset.filter;
        const filterTxt = link.dataset.filterText;
        const dropdown = link.closest('.blogFilters__dropdown');
        const toggle = dropdown.querySelector('.blogFilters__dropdown-toggle');
        const label = toggle.querySelector('.blogFilters__dropdown-label');

        // Highlight selected item
        dropdown.querySelectorAll('.blogFilters__dropdown-link').forEach(function (l) {
          l.classList.remove('blogFilters__dropdown-link--active');
        });
        link.classList.add('blogFilters__dropdown-link--active');

        // Update toggle label to show selection
        label.textContent = filterTxt;
        toggle.classList.add('blogFilters__dropdown-toggle--active');

        // Close dropdown
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('blogFilters__dropdown--open');

        // Update active filters
        activeFilters[taxonomy] = filterVal;

        // Show reset button
        const resetBtn = listingTwo.querySelector('.blogFilters__reset');
        if (resetBtn) resetBtn.style.display = '';

        currentPage = 1;
        filterPostsTwo();
        return;
      }

      // 3. Reset / clear all filters
      if (e.target.classList.contains('blogFilters__reset')) {
        e.preventDefault();
        activeFilters = {};

        listingTwo.querySelectorAll('.blogFilters__dropdown').forEach(function (dropdown) {
          const toggle = dropdown.querySelector('.blogFilters__dropdown-toggle');
          const label = toggle.querySelector('.blogFilters__dropdown-label');
          label.textContent = toggle.dataset.originalLabel || label.textContent;
          toggle.classList.remove('blogFilters__dropdown-toggle--active');
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('blogFilters__dropdown--open');
          dropdown.querySelectorAll('.blogFilters__dropdown-link').forEach(function (l) {
            l.classList.remove('blogFilters__dropdown-link--active');
          });
        });

        e.target.style.display = 'none';
        currentPage = 1;
        filterPostsTwo();
        return;
      }

      // 4. Legacy button-style filter (offers, newsinsights, etc.)
      if (e.target.classList.contains('blogFilters__link')) {
        e.preventDefault();
        const filterValue = e.target.dataset.filter;
        const taxonomy = e.target.closest('.blogFilters__list').dataset.taxonomy;

        listingTwo.querySelectorAll('.blogFilters__item').forEach(function (item) {
          item.classList.remove('blogFilters__item--active');
        });
        e.target.closest('.blogFilters__item').classList.add('blogFilters__item--active');

        if (filterValue && filterValue !== '') {
          activeFilters[taxonomy] = filterValue;
        } else {
          delete activeFilters[taxonomy];
        }

        currentPage = 1;
        filterPostsTwo();
      }
    });

    // Close dropdowns when clicking outside the filter area
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.blogFilters__dropdown')) {
        listingTwo.querySelectorAll('.blogFilters__dropdown--open').forEach(function (dropdown) {
          dropdown.classList.remove('blogFilters__dropdown--open');
          dropdown
            .querySelector('.blogFilters__dropdown-toggle')
            .setAttribute('aria-expanded', 'false');
        });
      }
    });

    // ---------------------------------------------------------------
    // Load more
    // ---------------------------------------------------------------
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const postType = btn.dataset.type;
        showNextItemsTwo(btn, postType);
      });
    }

    function filterPostsTwo() {
      const postType = btn ? btn.dataset.type : listingTwo.dataset.postType;
      const event = btn ? btn.dataset.event : listingTwo.dataset.event;
      const loadPostsContainer = document.querySelector('.blogListPostsTwo__loadPostsHere');
      const featuredContainer = listingTwo.querySelector('.blogListPostsTwo__featured');

      let data = {
        action: 'filter_' + postType,
        page: 1,
        security: loadmore_params.security,
        post_type: postType,
        event: event,
        filters: JSON.stringify(activeFilters)
      };

      fetch(loadmore_params.ajaxurl, {
        method: 'POST',
        body: new URLSearchParams(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            loadPostsContainer.innerHTML = data.data.posts;

            if (featuredContainer) {
              featuredContainer.innerHTML = data.data.featured || '';
              featuredContainer.hidden = !data.data.featured;
            }

            if (btn) {
              if (data.data.max_pages > 1) {
                btn.style.display = 'block';
                btn.dataset.maxNumPages = data.data.max_pages;
                btn.classList.remove('loading');
              } else {
                btn.style.display = 'none';
              }
            }
          } else {
            loadPostsContainer.innerHTML = '<div class="no-posts">No posts found.</div>';
            if (featuredContainer) {
              featuredContainer.innerHTML = '';
              featuredContainer.hidden = true;
            }
            if (btn) btn.style.display = 'none';
          }
        })
        .catch(error => {
          console.error('Filter error:', error);
          loadPostsContainer.innerHTML = '<div class="error-posts">Error loading posts.</div>';
        });
    }

    function showNextItemsTwo(button, postType) {
      button.classList.add('loading');

      let maxNumPages = button.dataset.maxNumPages;
      let event = button.dataset.event;
      currentPage++;

      let data = {
        action: 'loadmore_' + postType,
        query: loadmore_params.posts,
        page: currentPage,
        security: loadmore_params.security,
        max_num_pages: maxNumPages,
        post_type: postType,
        paged: currentPage,
        event: event,
        filters: JSON.stringify(activeFilters)
      };

      fetch(loadmore_params.ajaxurl, {
        method: 'POST',
        body: new URLSearchParams(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => response.text())
        .then(data => {
          if (data) {
            button.firstElementChild.textContent = 'Load more posts';

            let listingLoadPosts = document.querySelector('.blogListPostsTwo__loadPostsHere');
            listingLoadPosts.insertAdjacentHTML('beforeend', data);

            if (currentPage >= maxNumPages) {
              button.style.display = 'none';
            } else {
              button.classList.remove('loading');
            }
          } else {
            button.style.display = 'none';
          }
        })
        .catch(error => {
          button.firstElementChild.textContent = 'Load more posts';
          console.error(error);
        });
    }
  }
});
